/*
* Copyright Gregory Coburn 2020-2026, All Rights Reserved, See license for further details
*/
import { MyInjector } from '@src/app/app.module';
import { Field } from '@src/app/shared/field/Field';
import { SectionEditor } from '@src/app/shared/form/section-editor';
import { ServiceRequest } from '@src/app/model/serviceRequest';
import { RequestService } from '@src/app/modules/crm/request.service';

export class RequestSummaryEditor extends SectionEditor<ServiceRequest> {
    protected svc = MyInjector.instance.get(RequestService);
    protected title = $localize`Summary`;

    protected buildFields(): Field[] {
        return [
            ServiceRequest.getTitleField(),
            ServiceRequest.getDescriptionField({ heightInFields: 4 })
        ];
    }
}
